// extracted by mini-css-extract-plugin
export default {"actionButton":"CampaignDashboardCommunityUpdatesTab_actionButton__JNYbB","actionButtonContainer":"CampaignDashboardCommunityUpdatesTab_actionButtonContainer__i0Mod"};